import { ICON__plus } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { BUTTON__try_app } from '@/pages/_base/buttons/BUTTON__try_app';
import { ViewShortcutTrigger } from '@/pages/_base/shortcut_hint/ViewShortcutTrigger';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useTranslation } from 'react-i18next';
import { HOOK_USER_TASK__create } from './_hooks/HOOK_USER_TASK__create';
import { WATCHER_SHORTCUT__user_task_create } from './_watchers/WATCHER_SHORTCUT__user_task_create';

export function U_BUTTON__user_task_create() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_USER_TASKS);

  const { is_authorized } = use_slice_user(['is_authorized']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const { is_loading, create_user_task } = HOOK_USER_TASK__create();

  /*
   * HTML
   */

  if (!is_authorized) return <BUTTON__try_app />; //not authorized
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_USER_TASK_CREATE)) return <PLACEHOLDER_bar_line />;
  /*
   * HTML
   */
  return (
    <>
      <WATCHER_SHORTCUT__user_task_create />
      <ViewShortcutTrigger hint_shortcut_keys={[EShortcutType.USER_TASK_CREATE]}>
        <UI_PRIMITIVE__button
          className="px-4 py-2   font-medium text-sm rounded-lg shadow-lg  transition-colors"
          variant="no-border-on-bar"
          onClick={() => create_user_task(false)}
          disabled={is_loading}
        >
          <ICON__plus className="!size-3" />
        </UI_PRIMITIVE__button>
      </ViewShortcutTrigger>
    </>
  );
}
